import { ArrowPathIcon } from '@heroicons/react/24/outline'

export function RefreshButton(): JSX.Element {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <button
      type="button"
      onClick={handleRefresh}
      className="refresh-button flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-light text-white/80 transition-colors hover:bg-navy-light/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon-cyan focus-visible:ring-offset-2 focus-visible:ring-offset-navy"
      aria-label="Refresh page"
    >
      <ArrowPathIcon className="h-5 w-5" aria-hidden="true" />
    </button>
  )
}

